import { computed, Service, signal } from '@angular/core';
import { CategoriaServicosGrupo, CategoriaServicosItem } from '../models/categoria-servicos.model';

const ICONES = 'assets/images/icones-servicos';

/**
 * Grupo de EXEMPLO "Serviços digitais" deste mock. Não é a tela `/servicos-digitais`:
 * aquela lê os serviços reais da API (`ServicosDigitaisService`).
 */
const SERVICOS_DIGITAIS: readonly CategoriaServicosItem[] = [
  {
    id: 'financas',
    titulo: 'Finanças',
    descricao: 'IPTU, ISS e demais tributos municipais.',
    cor: 'verde',
    tipos: ['digital'],
    icone: `${ICONES}/icon-financas.svg`,
    rotaPagina: 'financas',
  },
  {
    id: 'limpeza',
    titulo: 'Limpeza',
    descricao: 'Varrição, coleta de lixo domiciliar e coleta de lixo reciclável.',
    cor: 'rosa',
    tipos: ['digital'],
    icone: `${ICONES}/icon-balde-limpeza.svg`,
    rotaPagina: 'limpeza',
  },
  {
    id: 'rua-e-bairro',
    titulo: 'Rua e bairro',
    descricao: 'Tapa-buraco e zeladoria da cidade.',
    cor: 'roxo',
    tipos: ['digital'],
    icone: `${ICONES}/icon-house.svg`,
    rotaPagina: 'rua-e-bairro',
  },
  {
    id: 'transito-transporte',
    titulo: 'Trânsito/Transporte',
    descricao: 'Circulação de veículos, ônibus e táxis.',
    cor: 'laranja',
    tipos: ['digital', 'presencial'],
    icone: `${ICONES}/icon-metro.svg`,
    rotaPagina: 'transito-transporte',
  },
  {
    id: 'iluminacao-publica',
    titulo: 'Iluminação pública',
    descricao: 'Troca de lâmpadas, manutenção de postes e novos pontos de luz.',
    cor: 'amarelo',
    tipos: ['digital', 'cadastro'],
    icone: `${ICONES}/icon-lampada-rua.svg`,
    rotaPagina: 'iluminacao-publica',
  },
  {
    id: 'tributos-e-taxas',
    titulo: 'Tributos e taxas',
    descricao: 'Dívida ativa, parcelamento de débitos e emissão de guias.',
    cor: 'vermelho',
    tipos: ['digital'],
    icone: `${ICONES}/icon-dinheiro.svg`,
    rotaPagina: 'tributos-e-taxas',
  },
  {
    id: 'agua-e-saneamento',
    titulo: 'Água e saneamento',
    descricao: 'Ligação de água, esgoto e limpeza de canais.',
    cor: 'azul',
    tipos: ['digital'],
    icone: `${ICONES}/icon-guarda-chuva.svg`,
    rotaPagina: 'agua-e-saneamento',
  },
  {
    id: 'zeladoria-urbana',
    titulo: 'Zeladoria urbana',
    descricao: 'Capinação, pintura de meio-fio e conservação de praças.',
    cor: 'verde',
    tipos: ['digital'],
    icone: `${ICONES}/icon-limpeza.svg`,
    rotaPagina: 'zeladoria-urbana',
  },
];

const GRUPOS: readonly CategoriaServicosGrupo[] = [
  {
    id: 'servicos-presenciais',
    titulo: 'Serviços presenciais',
    categorias: [
      {
        id: 'servico-funerario',
        titulo: 'Serviço funerário',
        descricao: 'Gratuidade, cremação, translado, sepultamento, zeladoria e ossuário.',
        cor: 'azul',
        tipos: ['presencial'],
        icone: `${ICONES}/icon-servico-funerario.svg`,
        rotaPagina: 'servico-funerario',
      },
      {
        id: 'bilhete-unico',
        titulo: 'Bilhete único',
        descricao: 'Comum, Especial (para deficientes e idosos) e vale transporte.',
        cor: 'vermelho',
        tipos: ['presencial', 'cadastro'],
        icone: `${ICONES}/icon-bilhete-unico.svg`,
        rotaPagina: 'bilhete-unico',
      },
      {
        id: 'animal',
        titulo: 'Animal',
        descricao: 'Animais domésticos e animais silvestres.',
        cor: 'roxo',
        tipos: ['presencial'],
        icone: `${ICONES}/icon-animal.svg`,
        rotaPagina: 'animal',
      },
      {
        id: 'assistencia-social',
        titulo: 'Assistência social',
        descricao: 'Operação Altas e Baixas Temperaturas, direitos humanos e programas sociais.',
        cor: 'amarelo',
        tipos: ['presencial', 'cadastro'],
        icone: `${ICONES}/icon-assistencia-social.svg`,
        rotaPagina: 'assistencia-social',
      },
      {
        id: 'memorial-e-cemiterios',
        titulo: 'Memorial e cemitérios',
        descricao: 'Concessão de jazigos, exumação e manutenção de cemitérios.',
        cor: 'rosa',
        tipos: ['presencial'],
        icone: `${ICONES}/icon-vela-memorial.svg`,
        rotaPagina: 'memorial-e-cemiterios',
      },
      {
        id: 'defesa-civil',
        titulo: 'Defesa civil',
        descricao: 'Risco de deslizamento, alagamentos e vistorias preventivas.',
        cor: 'verde',
        tipos: ['presencial', 'cadastro'],
        icone: `${ICONES}/icon-guarda-chuva.svg`,
        rotaPagina: 'defesa-civil',
      },
      {
        id: 'atendimento-ao-cidadao',
        titulo: 'Atendimento ao cidadão',
        descricao: 'Postos de atendimento, agendamento e protocolo de documentos.',
        cor: 'laranja',
        tipos: ['presencial'],
        icone: `${ICONES}/icon-house.svg`,
        rotaPagina: 'atendimento-ao-cidadao',
      },
      {
        id: 'feiras-e-mercados',
        titulo: 'Feiras e mercados',
        descricao: 'Permissão de uso de box, feiras livres e ambulantes.',
        cor: 'azul',
        tipos: ['presencial'],
        icone: `${ICONES}/icon-dinheiro.svg`,
        rotaPagina: 'feiras-e-mercados',
      },
    ],
  },
  {
    id: 'servicos-digitais',
    titulo: 'Serviços digitais',
    categorias: SERVICOS_DIGITAIS,
  },
  {
    id: 'servicos-de-cadastro',
    titulo: 'Serviços de cadastro',
    categorias: [
      {
        id: 'cadastro-unico',
        titulo: 'Cadastro Único',
        descricao: 'Inscrição e atualização cadastral para programas sociais.',
        cor: 'azul',
        tipos: ['cadastro'],
        icone: `${ICONES}/icon-assistencia-social.svg`,
        rotaPagina: 'cadastro-unico',
      },
      {
        id: 'cadastro-imobiliario',
        titulo: 'Cadastro imobiliário',
        descricao: 'Inscrição de imóvel, desdobro e alteração de titularidade.',
        cor: 'amarelo',
        tipos: ['cadastro'],
        icone: `${ICONES}/icon-house.svg`,
        rotaPagina: 'cadastro-imobiliario',
      },
      {
        id: 'cadastro-de-animais',
        titulo: 'Cadastro de animais',
        descricao: 'Registro de animais domésticos e de tutores.',
        cor: 'roxo',
        tipos: ['cadastro'],
        icone: `${ICONES}/icon-animal.svg`,
        rotaPagina: 'cadastro-de-animais',
      },
      {
        id: 'cadastro-de-ambulantes',
        titulo: 'Cadastro de ambulantes',
        descricao: 'Licença de comércio ambulante e renovação anual.',
        cor: 'verde',
        tipos: ['cadastro'],
        icone: `${ICONES}/icon-dinheiro.svg`,
        rotaPagina: 'cadastro-de-ambulantes',
      },
      {
        id: 'cadastro-transporte-escolar',
        titulo: 'Cadastro de transporte escolar',
        descricao: 'Habilitação de condutores e vistoria de veículos escolares.',
        cor: 'vermelho',
        tipos: ['cadastro'],
        icone: `${ICONES}/icon-bilhete-unico.svg`,
        rotaPagina: 'cadastro-transporte-escolar',
      },
      {
        id: 'cadastro-taxi-mototaxi',
        titulo: 'Cadastro de táxi e mototáxi',
        descricao: 'Permissão de praça, credencial e transferência.',
        cor: 'laranja',
        tipos: ['cadastro'],
        icone: `${ICONES}/icon-metro.svg`,
        rotaPagina: 'cadastro-taxi-mototaxi',
      },
      {
        id: 'cadastro-coleta-seletiva',
        titulo: 'Cadastro de coleta seletiva',
        descricao: 'Adesão de cooperativas e pontos de entrega voluntária.',
        cor: 'rosa',
        tipos: ['cadastro'],
        icone: `${ICONES}/icon-balde-limpeza.svg`,
        rotaPagina: 'cadastro-coleta-seletiva',
      },
      {
        id: 'cadastro-do-contribuinte',
        titulo: 'Cadastro do contribuinte',
        descricao: 'Inscrição municipal, alvará e baixa de atividade.',
        cor: 'azul',
        tipos: ['cadastro'],
        icone: `${ICONES}/icon-financas.svg`,
        rotaPagina: 'cadastro-do-contribuinte',
      },
    ],
  },
];

/**
 * Categorias de EXEMPLO — mock. Alimentam só as rotas de exemplo que o `servicoExisteGuard`
 * aceita (`/animal`, `/financas`…) e o título de exemplo de `pages-servicos`.
 *
 * Nem a seção "Categorias de serviços" da homepage nem a tela `/categorias-servicos` usam
 * mais este serviço: as duas leem as categorias cadastradas no adm pelo
 * `CategoriasPublicasService`.
 */
@Service()
export class CategoriaServicosService {
  private readonly grupos = signal(GRUPOS);

   readonly gruposCategoriaServicos = this.grupos.asReadonly();

   readonly categoriaServicos = computed(() =>
    this.grupos().flatMap((grupo) => grupo.categorias)
  );
}
